import request from '@/api/request'
// 列表
const getCouponList = (params) => {
  return request({
    url: '/api/v1/coupon/app/listCoupon',
    method: 'POST',
    data: params,
    domain: 'coupon'
  })
}
// 详情
const getCouponItem = (params) => {
  return request({
    url: `/api/v1/coupon/app/getCoupon`,
    method: 'POST',
    data: params,
    domain: 'coupon'
  })
}
// 通过手机号优惠券号获取订单号
const getOrderNo = (params, userMobile) => {
  return request({
    url: `/api/v1/coupon/app/getOrderNo?couponCode=${params}&&userMobile=${userMobile}`,
    method: 'GET',
    domain: 'coupon'
  })
}
// 查询账户名下VIN码列表
const getlistVin = (params) => {
  return request({
    url: `/api/v1/coupon/app/getAccountVins`,
    method: 'GET',
    // url: `/api/v1/coupon/app/listVin`,
    // method: 'POST',
    data: params,
    domain: 'coupon'
  })
}
// 卡券激活
const setActiveCoupon = (params) => {
  return request({
    url: `/api/v1/coupon/app/activeCoupon`,
    method: 'POST',
    data: params,
    domain: 'coupon'
  })
}
// 获取神券详情
export const getCanGiveCouponDetail = data => {
  return request({
    url: `/api/v1/coupon/app/getCouponDetail`,
    method: 'post',
    data,
    domain: 'coupon',
    noTenantId: true
  })
}
export default { getCouponList, getCouponItem, getOrderNo, getlistVin, setActiveCoupon, getCanGiveCouponDetail }
